module.exports = __webpack_public_path__ + "img/Refund Money.8d4b9fcd.svg";